"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = users;
function users() {
  var _this = this;

  return {
    profile: function profile(username) {
      var url = "/users/" + username;

      return _this.request({
        url: url,
        method: "GET"
      });
    },

    photos: function photos(username) {
      var page = arguments.length <= 1 || arguments[1] === undefined ? 1 : arguments[1];
      var perPage = arguments.length <= 2 || arguments[2] === undefined ? 10 : arguments[2];
      var orderBy = arguments.length <= 3 || arguments[3] === undefined ? "latest" : arguments[3];

      var url = "/users/" + username + "/photos";
      var query = {
        page: page,
        per_page: perPage,
        order_by: orderBy
      };

      return _this.request({
        url: url,
        method: "GET",
        query: query
      });
    },

    likes: function likes(username) {
      var page = arguments.length <= 1 || arguments[1] === undefined ? 1 : arguments[1];
      var perPage = arguments.length <= 2 || arguments[2] === undefined ? 10 : arguments[2];
      var orderBy = arguments.length <= 3 || arguments[3] === undefined ? "latest" : arguments[3];

      var url = "/users/" + username + "/likes";
      var query = {
        page: page,
        per_page: perPage,
        order_by: orderBy
      };

      return _this.request({
        url: url,
        method: "GET",
        query: query
      });
    },

    collections: function collections(username) {
      var page = arguments.length <= 1 || arguments[1] === undefined ? 1 : arguments[1];
      var perPage = arguments.length <= 2 || arguments[2] === undefined ? 10 : arguments[2];

      var url = "/users/" + username + "/collections";
      var query = {
        page: page,
        per_page: perPage
      };

      return _this.request({
        url: url,
        method: "GET",
        query: query
      });
    }
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/unsplash-js/lib/methods/users.js
 ** module id = 528
 ** module chunks = 0
 **/